import { render, staticRenderFns } from "./InsSlideMenu.vue?vue&type=template&id=2eedf4fd&scoped=true&"
import script from "./InsSlideMenu.vue?vue&type=script&lang=ts&"
export * from "./InsSlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./InsSlideMenu.vue?vue&type=style&index=0&id=2eedf4fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eedf4fd",
  null
  
)

export default component.exports